import { useState } from 'react';
import { Link } from 'react-router';
import { useCollapse } from 'react-collapsed';
import normalize from 'components/Dashboard/utilities/normalizeString';
import CollapsibleSection, {
  onEnterOrSpace,
} from 'components/Dashboard/StakeHolders/StakeholderPage/ui/CollapsibleSection';

const Staffers = (props) => {
  const { staff } = props;
  const [isExpandedShowMore, setExpandedShowMore] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded: isExpandedShowMore });
  const toggleShowMore = () => setExpandedShowMore((prevExpanded) => !prevExpanded);

  const firstStaffers = staff.slice(0, 10);
  const remainingStaffers = staff.slice(10);

  return (
    <CollapsibleSection title='Staff'>
      <div className='pt-1'>
        {firstStaffers.map((staffer, index) => {
          return <StaffersElement staffer={staffer} key={`first-staffer-${index}`} />;
        })}
      </div>
      {remainingStaffers.length > 0 && (
        <>
          <div {...getCollapseProps()}>
            {remainingStaffers.map((staffer, index) => {
              return <StaffersElement staffer={staffer} key={`remaining-staffer-${index}`} />;
            })}
          </div>
          <div
            {...getToggleProps({ onClick: toggleShowMore, onKeyDown: onEnterOrSpace(toggleShowMore) })}
            className='mt-2'
          >
            <span
              className={`light-60-text dropdown-item-element paragraph-p2 dropdown-item-element-9 d-inline-block ${
                isExpandedShowMore ? 'open' : ''
              }`}
            >
              {isExpandedShowMore ? 'Show less' : 'Show more'}
            </span>
          </div>
        </>
      )}
    </CollapsibleSection>
  );
};

const StaffersElement = (props) => {
  const { staffer } = props;
  const { officalName, id } = staffer ?? {};
  const isDeleted = officalName?.endsWith('(Deleted)');

  const content = (
    <p className={`mb-0`}>
      <span className='icon-profile mr-2 d-inline-block-centered' />
      {officalName}
    </p>
  );

  return (
    <div className='my-2 member-data flex-centered'>
      {isDeleted ? (
        content
      ) : (
        <Link className='reset-link light-70-text general-link ' to={`/stakeholders/${id}/${normalize(officalName)}`}>
          {content}
        </Link>
      )}
    </div>
  );
};

export default Staffers;
